var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flex',{attrs:{"gap":_vm.gap}},_vm._l((Number(_vm.count)),function(x){return _c('icon',{key:x,attrs:{"icon":_vm.icon,"color":_vm.color}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }